import { t } from "@lingui/core/macro";
import { QueryCache, QueryClient } from "@tanstack/react-query";
import { toast } from "@warp-ds/elements/toast";

export const makeQueryClient = () => {
	return new QueryClient({
		queryCache: new QueryCache({
			onError: () => {
				toast(t`Vi har problemer med å laste denne siden. Prøv på nytt.`, {
					type: "error",
					id: "query-error",
				});
			},
		}),
		defaultOptions: {
			queries: {
				staleTime: 5 * (60 * 1000), // 5 min
				retry: false,
			},
		},
	});
};
